<template>
    <div :class="[ 'sidebar-navigation', {'loading': status !== 'ready'} ]">
        <p v-if="status === 'loading'"><i class="fas fa-circle-notch fa-spin"></i></p>
        <button class="retry" @click="init()" v-if="status === 'error'"><i class="fas fa-sync"></i>Retry</button>
        <template v-if="status === 'ready'">
            <div class="navigation-group" v-for="(navigationGroup, groupIndex) in navigationGroups" :key="groupIndex">
                <h4 class="group-label" v-if="groupHasLabel(navigationGroup)">{{ navigationGroup.Text }}</h4>
                <ul class="group-links" v-if="groupHasLinks(navigationGroup)">
                    <li class="group-link" v-for="(navigationItem, linkIndex) in navigationGroup.SideBarNavItem" :key="`${groupIndex}-${linkIndex}`">
                        <router-link class="group-link-item" v-if="navigationItemIsLink(navigationItem)" :to=navigationItem.Payload>
                            <i :class="navigationItem.Icon" v-if="navigationItemHasIcon(navigationItem)"></i>
                            {{ navigationItem.Text }}
                        </router-link>
                        <button class="group-link-item" v-if="navigationItemIsActionButton(navigationItem)" @click="callFunction(navigationItem.Payload)">
                            <i :class="navigationItem.Icon" v-if="navigationItemHasIcon(navigationItem)"></i>
                            {{ navigationItem.Text }}
                        </button>
                        <a :href="navigationItem.Payload" class="group-link-item" v-if="navigationItemIsExternalLink(navigationItem)">
                            <i :class="navigationItem.Icon" v-if="navigationItemHasIcon(navigationItem)"></i>
                            {{ navigationItem.Text }}
                        </a>
                    </li>
                </ul>
            </div>
        </template>
    </div>
</template>

<script>
import UIService from "@/services/UIService";

export default {
    name: "sidebar-navigation",
    data() {
        return {
            status: "ready",
            navigationGroups: []
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            this.status = "loading";
            try {
                let response = await UIService.getSidebarNavigation();
                this.navigationGroups = response.data;
                this.status = "ready";
            } catch(e) {
                this.status = "error";
                this.navigationGroups = [];
            }
        },
        groupHasLabel(navigationGroup) {
            return navigationGroup.Text && navigationGroup.Text.length;
        },
        groupHasLinks(navigationGroup) {
            return navigationGroup.SideBarNavItem && navigationGroup.SideBarNavItem.length;
        },
        navigationItemHasIcon(navigationItem) {
            return navigationItem.Icon && navigationItem.Icon.length;
        },
        navigationItemIsLink(navigationItem) {
            return navigationItem.Type && navigationItem.Type === "link";
        },
        navigationItemIsActionButton(navigationItem) {
            return navigationItem.Type && navigationItem.Type === "action";
        },
        navigationItemIsExternalLink(navigationItem) {
            return navigationItem.Type && navigationItem.Type === "external-link";
        },
        callFunction(functionName) {
            this[functionName]();
        },
        openFeedback() {
            // 
        }
    }
}
</script>

<style lang="scss" scoped>
.sidebar-navigation {
    &.loading {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        color: $white;
        font-size: 18px;
        .retry {
            font-size: 14px;
            color: $white;
            background: none;
            @include removeBootstrapOutline;
            @include fastestTransition;
            i {
                margin: 0px 10px 0px 0px;
            }
        }
    }
    .navigation-group {
        margin: 0px 0px 25px 0px;
        .group-label {
            margin: 0 0 8px 0;
            padding: 0px $sidebar-padding;
            font-family: $raleway;
            font-size: 13px;
            font-weight: 700;
            text-transform: uppercase;
            color: $light-blue;
        }
        .group-links {
            padding: 0;
            margin: 0;
            list-style: none;
            .group-link {
                margin: 0;
                padding: 0;
                .group-link-item {
                    display: flex;
                    align-items: center;
                    justify-content: flex-start;
                    width: 100%;
                    padding: 5px $sidebar-padding;
                    font-size: 15px;
                    font-family: $lato;
                    font-weight: 400;
                    text-decoration: none!important;
                    background: transparent;
                    color: $white!important;
                    cursor: pointer;
                    @include removeBootstrapOutline;
                    @include fastestTransition;
                    i {
                        margin: 0px 10px 0px 0px;
                        font-size: 13px;
                    }
                    &:hover {
                        background-color: darken($primary, 7%);
                    }
                }
            }
        }
        &:last-child {
            margin: 0;
        }
    }
}

.dark {
    .sidebar-navigation {
        &.loading {
            color: $light-gray;
            .retry {
                color: $light-gray;
            }
        }
        .navigation-group {
            .group-label {
                color: $darker-gray;
            }
            .group-links {
                .group-link {
                    .group-link-item {
                        color: $light-gray!important;
                        &:hover {
                            background-color: $extra-darker-gray;
                        }
                    }
                }
            }
        }
    }
}
</style>
